"use client"

import { useContext, useState } from "react"
import { useAuth } from "@/context/AuthContext";
import Link from "next/link";
import {
  BadgeCheck,
  Bell,
  CreditCard,
  FlaskConical,
  Laptop,
  LogOut,
  Moon,
  Settings,
  Sparkles,
  Sun,
  SunMoon,
  User,
} from "lucide-react"

import {
  Avatar,
  AvatarFallback,
} from "@/components/ui/avatar"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
} from "@/components/ui/dropdown-menu"
import { Button } from "@/components/ui/button";
import { useTheme } from "next-themes";
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip";

export function UserButton() {

  const { user, signOut } = useAuth();
  const { setTheme } = useTheme()

  if (!user) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <Link href="/sign-in">
            <Button
              variant="default"
              size="icon"
              className="rounded-full"
            >
              <User/>
            </Button>
          </Link>
        </TooltipTrigger>
        <TooltipContent>
          Sign in
        </TooltipContent>
      </Tooltip>
    )
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="default" size="icon">
          {user?.first_name?.charAt(0)}{user?.last_name?.charAt(0)}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="min-w-56"
        side={"bottom"}
        align={"end"}
        sideOffset={16}
      >
        <DropdownMenuLabel>
          {user?.first_name} {user?.last_name}
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuGroup>
          {user?.tier === "free" &&
            <Link href="/pricing">
              <DropdownMenuItem>
                <Sparkles className='size-4 stroke-[1.5]' />
                Subscribe
              </DropdownMenuItem>
            </Link>
          }
          {user?.tier !== "free" &&
            <Link href="/account">
              <DropdownMenuItem>
                <CreditCard className='size-4 stroke-[1.5]' />
                Manage subscription
              </DropdownMenuItem>
            </Link>
          }
          {/* <DropdownMenuItem disabled>
            <FlaskConical className='size-4 stroke-[1.5]' />
            Experimental features
          </DropdownMenuItem> */}
        </DropdownMenuGroup>
        {/* <DropdownMenuSeparator /> */}
        <DropdownMenuGroup>
          <Link href="/account">
            <DropdownMenuItem>
              <User className='size-4 stroke-[1.5]' />
              Account
            </DropdownMenuItem>
          </Link>
          <Link href="/preferences">
            <DropdownMenuItem>
              <Settings className='size-4 stroke-[1.5]' />
              Preferences
            </DropdownMenuItem>
          </Link>
        </DropdownMenuGroup>
        <DropdownMenuSeparator />
        <DropdownMenuLabel>
          Theme
        </DropdownMenuLabel>
        <DropdownMenuItem onClick={() => setTheme("light")}>
          <Sun className='size-4 stroke-[1.5]' /> Light
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setTheme("dark")}>
          <Moon className='size-4 stroke-[1.5]' /> Dark
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setTheme("system")}>
          <Laptop className='size-4 stroke-[1.5]' /> System
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={signOut}>
          <LogOut className='size-4 stroke-[1.5]' />
          Sign out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
